// We can use this module as getters for the store state
// We can put this into each redux slice

export const selectGlobalUnit = (key) => (state) => {
    return state.billingData?.globalUnits?.find(unit => unit.id === key)?.data;    
}